export type TEventDetail<TPayload> = {
  type: string;
} & TPayload;

const sendCustomEvent = (
  eventChannel: string,
  eventType: string,
  payload: Record<string, unknown> = {},
) => {
  const event = new CustomEvent(eventChannel, {
    detail: {
      type: eventType,
      ...payload,
    },
  });

  document.dispatchEvent(event);
};

export default sendCustomEvent;
